import React, {useState} from 'react'
import {Row, Col, Form} from 'react-bootstrap';

import ZFormDate from './ZFormDate'

export default function ZForm({elements, onChange}) {

    const [formName] = useState('form' + Math.random() * (+100000 - +1) + +1);

    /**
     * Render un elemento
     */
    const renderElement = (formElem, idx) => {

        let content;
        switch (formElem.type) {

            // Date
            case 'date':
                content =
                    <ZFormDate
                        name={formElem.name}
                        value={formElem.value}
                        onChange={onChange}
                    />
                break;

            // Selector
            case 'select':
                content = (
                    <Form.Control as="select" value={formElem.value}
                                  onChange={ev => onChange({name: formElem.name, value: ev.target.value})}>
                        {formElem.options && formElem.options.map((op, key) => (
                            <option key={key} value={op.value}>{op.label}</option>
                        ))}
                    </Form.Control>
                )
                break;

            // Input, textarea
            case 'textarea':
            case 'input':
            default:
                content = (
                    <Form.Control
                        as={formElem.type || 'input'}
                        name={formElem.name || ''}
                        value={formElem.value}
                        disabled={formElem.disabled}
                        onChange={(ev) => onChange({name: formElem.name, value: ev.target.value})}
                    />
                );
        }

        return (
            <Col key={formName + idx} md={formElem.md}>
                <Form.Group>
                    {formElem.label && <Form.Label>{formElem.label}</Form.Label>}
                    {content}
                </Form.Group>
            </Col>
        )
    }

    // -----| Render |-----
    return (
        <Row>
            {elements && elements.map((e, i) => renderElement(e, i))}
        </Row>
    );
}
